import { Schemas } from '~/api/gen'
import { MetaData } from '~/components/Meta'
import { getUserNameForSeo } from '~/lib/getUserNameForSeo'

const getTitle = (member: Schemas.member_large_detail): string => {
  return `${getUserNameForSeo({
    nickname: member.nick_name,
    wearista: member.is_wearista,
    shopClerk: member.is_shop_clerk,
    shopName: member.shop?.name,
  })}のお気に入りフォルダ一覧`
}

export const getMetadata = (
  member: Schemas.member_large_detail,
  totalCount: number
): MetaData => {
  return {
    title: getTitle(member),
    description: `${member.nick_name}のお気に入りフォルダ一覧です。${member.nick_name}が好きなコーデやほしいアイテムをチェックできます！WEARはモデル・俳優・ショップスタッフなどの着こなしをチェックできるファッションコーディネートサイトです。`,
    ogImageUrl: member.image.url_640 ?? undefined,
    url: `https://wear.jp/${member.user_name}/favorite/`,
    appUrl: `wear2020://wear.jp/user/${member.id}/`,
    robots: totalCount !== 0,
  }
}
